import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "placeholder col-5 placeholder-xs sh-background-gray-blueish rounded-pill"
};
var _hoisted_2 = {
  key: 1,
  "class": "font-size-14 font-weight-semibold text-truncate"
};
var _hoisted_3 = {
  key: 0,
  "class": "d-flex align-items-center"
};
var _hoisted_4 = {
  "class": "d-flex h-100"
};
var _hoisted_5 = {
  "class": "mt-auto w-100"
};
var _hoisted_6 = {
  key: 1,
  "class": "message-sent"
};
import { ref, onMounted, onUpdated } from 'vue';
import { useUserStore } from '@dashboardApp/stores/UserStore';
import ArchiveMessageButton from './ArchiveMessageButton';
import Compose from '@dashboardApp/components/inbox/Compose';
import DatedMessagesInner from './DatedMessagesInner';
import ThrottleStatus from './ThrottleStatus';
import FlagButton from '@dashboardApp/components/supplier/FlagButton.vue';
import MessageLoader from '@dashboardApp/components/loader/MessageLoader.vue';
export default {
  __name: 'DatedMessagesMobile',
  props: {
    threadId: {
      type: [String, Number]
    },
    groupedMessages: {
      type: Object,
      "default": {}
    },
    hasThreadMessages: {
      type: Boolean,
      "default": false
    },
    from: {
      type: Object,
      "default": {}
    },
    isArchived: {
      type: Boolean,
      "default": false
    },
    withReply: {
      type: Boolean,
      "default": false
    },
    // Data is loading
    isLoading: {
      type: Boolean,
      "default": false
    },
    isInitiallyLoading: {
      type: Boolean,
      "default": false
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var props = __props;
    var userStore = useUserStore();
    var show = ref(false);
    var messagesScrollEl = ref(null);
    onMounted(function () {
      // Add delay for the transition effect
      setTimeout(function () {
        return show.value = true;
      }, 500);
    });
    var prevScrollHeight;
    onUpdated(function () {
      if (props.isInitiallyLoading || props.isLoading) {
        return;
      }
      if (prevScrollHeight) {
        // Remaion on previous and last row on scroll up
        messagesScrollEl.value.scrollTop = messagesScrollEl.value.scrollHeight - prevScrollHeight;
      } else {
        // Scroll down to the bottom of the messages
        messagesScrollEl.value.scrollTop = messagesScrollEl.value.scrollHeight;
      }
      prevScrollHeight = messagesScrollEl.value.scrollHeight;
    });
    __expose({
      messagesScrollEl: messagesScrollEl
    });
    return function (_ctx, _cache) {
      var _unref$user;
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["offcanvas offcanvas-end border-0 inquire-content", {
          show: show.value
        }]),
        id: "msg-01"
      }, [_createElementVNode("div", {
        "class": _normalizeClass([{
          loader: __props.isInitiallyLoading
        }, "offcanvas-header border-bottom border-gray-blueish px-4"])
      }, [_createElementVNode("div", {
        "class": _normalizeClass([{
          'placeholder-glow flex-grow-1': __props.isInitiallyLoading
        }, "d-flex align-items-center min-w-0"])
      }, [_createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          show.value = false;
          _ctx.$router.push({
            name: 'inbox'
          });
        }),
        "class": "",
        href: "#",
        "data-bs-dismiss": "offcanvas",
        "aria-label": "Close"
      }, _cache[1] || (_cache[1] = [_createElementVNode("img", {
        src: "/img/v5/db-ic_arrow-back.svg"
      }, null, -1)])), __props.isInitiallyLoading ? (_openBlock(), _createElementBlock("span", _hoisted_1)) : _createCommentVNode("", true), __props.hasThreadMessages ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.from.name), 1)) : _createCommentVNode("", true)], 2), __props.hasThreadMessages ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(ArchiveMessageButton), {
        id: __props.threadId,
        isArchived: __props.isArchived,
        archiveClass: "mx-2"
      }, {
        archiveImg: _withCtx(function () {
          return _cache[2] || (_cache[2] = [_createElementVNode("img", {
            src: "/img/v5/db-ic_archive-lg.svg"
          }, null, -1)]);
        }),
        unarchiveImg: _withCtx(function () {
          return _cache[3] || (_cache[3] = [_createElementVNode("img", {
            src: "/img/v5/db-ic_unarchive-lg.svg"
          }, null, -1)]);
        }),
        _: 1
      }, 8, ["id", "isArchived"]), __props.from.supplier.id ? (_openBlock(), _createBlock(FlagButton, {
        key: 0,
        supplierId: __props.from.supplier.id,
        supplierWebsite: __props.from.supplier.website,
        btnClass: "text-decoration-none d-inline-block ms-2 hover-opacity"
      }, {
        "default": _withCtx(function () {
          return _cache[4] || (_cache[4] = [_createElementVNode("img", {
            src: "/img/v5/db-ic_flag_lg.svg"
          }, null, -1)]);
        }, undefined, true),
        _: 1
      }, 8, ["supplierId", "supplierWebsite"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
        ref_key: "messagesScrollEl",
        ref: messagesScrollEl,
        "class": "offcanvas-body px-4 scrollbox position-relative scroll-bottom"
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [__props.isLoading ? (_openBlock(), _createBlock(MessageLoader, {
        key: 0
      })) : _createCommentVNode("", true), __props.hasThreadMessages ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groupedMessages, function (messages, date) {
        return _openBlock(), _createBlock(_unref(DatedMessagesInner), {
          messageRowClass: "mt-4",
          messages: messages,
          date: date
        }, null, 8, ["messages", "date"]);
      }), 256)), _createVNode(_unref(ThrottleStatus), {
        status: (_unref$user = _unref(userStore).user) === null || _unref$user === void 0 ? void 0 : _unref$user.throttleStatus
      }, null, 8, ["status"])])) : _createCommentVNode("", true)])])], 512), _createVNode(_unref(Compose), {
        from: __props.from,
        "show-form": __props.withReply,
        "is-mobile": true
      }, null, 8, ["from", "show-form"])], 2);
    };
  }
};